/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AppStatsDto } from '../models';
/**
 * AppStatsReaderRestApi - axios parameter creator
 * @export
 */
export const AppStatsReaderRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Total Login Count and Development Plans Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/public/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppStatsReaderRestApi - functional programming interface
 * @export
 */
export const AppStatsReaderRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppStatsReaderRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Total Login Count and Development Plans Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppStatsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AppStatsReaderRestApi.getAppStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AppStatsReaderRestApi - factory interface
 * @export
 */
export const AppStatsReaderRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppStatsReaderRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Total Login Count and Development Plans Count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppStats(options?: RawAxiosRequestConfig): AxiosPromise<AppStatsDto> {
            return localVarFp.getAppStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppStatsReaderRestApi - interface
 * @export
 * @interface AppStatsReaderRestApi
 */
export interface AppStatsReaderRestApiInterface {
    /**
     * 
     * @summary Get Total Login Count and Development Plans Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppStatsReaderRestApiInterface
     */
    getAppStats(options?: RawAxiosRequestConfig): AxiosPromise<AppStatsDto>;

}

/**
 * AppStatsReaderRestApi - object-oriented interface
 * @export
 * @class AppStatsReaderRestApi
 * @extends {BaseAPI}
 */
export class AppStatsReaderRestApi extends BaseAPI implements AppStatsReaderRestApiInterface {
    /**
     * 
     * @summary Get Total Login Count and Development Plans Count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppStatsReaderRestApi
     */
    public getAppStats(options?: RawAxiosRequestConfig) {
        return AppStatsReaderRestApiFp(this.configuration).getAppStats(options).then((request) => request(this.axios, this.basePath));
    }
}

